import React from "react";
import AddIcon from "@mui/icons-material/Add";
import {
  IStorageNodeProviderFind,
  IStorageNodeProviderLightFilterParams,
} from "api/entities/storage-node-providers";
import { connect } from "react-redux";
import { Action } from "redux";
import { ThunkDispatch } from "redux-thunk";
import { storageNodeProviderThunkActions } from "redux/actions/storage-provider";
import { IAppState } from "redux/reducers";
import { routeUtils } from "utils/route-utils";
import styles from "./storage-provider.module.scss";
import { IStoragePoolFilters } from "components/shard-clusters/filters/filters";
import {
  filterNames,
  defaultFilters,
} from "components/shard-repositories/filters/filters";
import RefreshButton from "components/shared-ui/button/refresh-button";
import { FiltersData } from "components/shared-ui/filters-data/filters-data/filters-data";
import PageTitle from "components/shared-ui/pageTitle";
import Button from "components/shared-ui/button";
import { IShardClusterFilterParams } from "api/entities/shard-cluster";
import { useNavigate } from "react-router-dom";
import { useFilters } from "utils/hooks/use-filter";
import { StorageProviderTable } from "./table/storage-provider-table";
import {
  IStorageNodeProviderFilters,
  StorageNodeProviderFilters,
  StorageNodeProviderFilterTypeMap,
} from "./filters";
import { TemplatePanelContainer } from "./template-panel/TemplatePanelContainer";

const mapDispatchToProps = (
  dispatch: ThunkDispatch<IAppState, void, Action>
) => {
  return {
    fetchPage: (params: IStorageNodeProviderFind) =>
      dispatch(storageNodeProviderThunkActions.entity.fetchPage(params)),
  };
};

interface IStorageProvidersProps
  extends ReturnType<typeof mapDispatchToProps> {}

export const StorageProviders = connect(
  null,
  mapDispatchToProps
)((props: IStorageProvidersProps) => {
  const navigate = useNavigate();
  const [filters, , updateQuery] = useFilters(
    { searchText: null },
    requestData,
    StorageNodeProviderFilterTypeMap,
    filtersToQueryParams,
    queryParamsToFilters
  );

  function filtersToQueryParams(
    filters: IStoragePoolFilters
  ): IShardClusterFilterParams {
    return {
      q: filters.searchText,
    };
  }

  function queryParamsToFilters(
    queryParams: Partial<IStorageNodeProviderLightFilterParams>
  ): IStoragePoolFilters {
    return {
      searchText: queryParams.q,
    };
  }

  function requestData(filters: IStorageNodeProviderFilters) {
    props.fetchPage({
      ...filtersToQueryParams(filters),
      offset: 0,
    });
  }

  const handleTemplateFormPanelOpen = () =>
    navigate(routeUtils.getRouteToStorageProviderTemplate());
  const handleAddProvideFormPanelOpen = () =>
    navigate(routeUtils.getRouteToNewStorageProvider());
  const handleFormPanelClose = () =>
    navigate(routeUtils.getRouteToStorageProviderList());
  return (
    <>
      <div className={styles.header}>
        <PageTitle title={`Shard Repository Providers`}>
          <RefreshButton onClick={() => props.fetchPage({})} />
        </PageTitle>
        <Button
          className={styles.add}
          responsive={true}
          testId="new-storage-pool-button"
          colors="primary"
          onClick={handleTemplateFormPanelOpen}
        >
          <span className={styles["hidden-on-small-screen"]}>
            View Template
          </span>
          <span className={styles["add__md"]}>Template</span>
        </Button>
        {/* <Button
          className={styles.add}
          responsive={true}
          disabled
          testId="new-storage-pool-button"
          colors="primary"
          onClick={handleAddProvideFormPanelOpen}
        >
          <AddIcon />
          <span className={styles["hidden-on-small-screen"]}>New Provider</span>
          <span className={styles["add__md"]}>Add New</span>
        </Button> */}
      </div>

      <StorageNodeProviderFilters
        filters={filters}
        onFiltersChange={updateQuery}
      />
      <FiltersData
        filterNames={filterNames}
        defaultFilters={defaultFilters}
        filters={filters}
        onFiltersChange={updateQuery}
      />
      <StorageProviderTable />
      <TemplatePanelContainer onClose={handleFormPanelClose} isReadonly/>
      {/* <ShardClusterPanel
        embedded={false}
        onClose={handleAddShardClusterFormPanelClose}
      /> */}
      {/* <ShardRepositoryPanelContainer />
      <DeleteConfirmation />
      <DeleteBlockedConfirmation /> */}
    </>
  );
});
